module.exports = __webpack_public_path__ + "img/index-banner.b83e358c.png";